/* global debounce */
if (!customElements.get('cart-machine')) {
  const ATTRIBUTE_NAMES = { make: 'Machine Make', model: 'Machine Model', high_flow: 'High Flow' };
  const FIT_CHECKER_STORAGE_KEY = 'sss_machine';

  class CartMachine extends HTMLElement {
    connectedCallback() {
      this.textInputs = Array.from(this.querySelectorAll('input[type="text"][data-machine-field]'));
      this.highFlowCheckbox = this.querySelector('[data-machine-field="high_flow"]');
      this.highFlowValue = this.querySelector('[data-machine-high-flow-value]');
      this.debouncedSave = debounce(this.save.bind(this), 400);
      this.handleInput = this.handleInput.bind(this);
      this.addEventListener('input', this.handleInput);

      // Save on first render so every order carries a High Flow Yes/No, even
      // when the customer never touches the checkbox, and so carts filled in
      // before the note block existed get one.
      if (this.prefillFromFitChecker() || !this.dataset.savedHighFlow || this.dataset.noteOutOfDate === 'true') {
        this.save();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('input', this.handleInput);
    }

    handleInput() {
      if (window.CartMachineNote) window.CartMachineNote.preview({ attributes: this.currentAttributes() });
      this.debouncedSave();
    }

    // The fit checker remembers the visitor's machine; reuse it so most buyers
    // arrive with the fields already filled in. Returns true if anything changed.
    prefillFromFitChecker() {
      const hasTextValue = this.textInputs.some((input) => input.value.trim() !== '');
      if (hasTextValue && this.dataset.savedHighFlow) return false;

      let saved = null;
      try {
        saved = JSON.parse(localStorage.getItem(FIT_CHECKER_STORAGE_KEY) || 'null');
      } catch (e) {
        return false;
      }
      if (!saved) return false;

      let changed = false;
      if (!hasTextValue) {
        this.textInputs.forEach((input) => {
          const value = saved[input.dataset.machineField];
          if (value) {
            input.value = value;
            changed = true;
          }
        });
      }
      if (!this.dataset.savedHighFlow && saved.flow === 'high') {
        this.highFlowCheckbox.checked = true;
        changed = true;
      }
      return changed;
    }

    currentAttributes() {
      const attributes = {};
      this.textInputs.forEach((input) => {
        attributes[ATTRIBUTE_NAMES[input.dataset.machineField]] = input.value.trim();
      });
      attributes[ATTRIBUTE_NAMES.high_flow] = this.highFlowCheckbox.checked ? 'Yes' : 'No';
      this.highFlowValue.value = attributes[ATTRIBUTE_NAMES.high_flow];
      return attributes;
    }

    save() {
      const attributes = this.currentAttributes();
      this.dataset.savedHighFlow = attributes[ATTRIBUTE_NAMES.high_flow];

      // Cart page and cart drawer can both be on the page; keep them in step.
      document.querySelectorAll('cart-machine').forEach((el) => {
        if (el === this) return;
        el.querySelectorAll('input[type="text"][data-machine-field]').forEach((input) => {
          input.value = attributes[ATTRIBUTE_NAMES[input.dataset.machineField]];
        });
        el.querySelector('[data-machine-field="high_flow"]').checked = this.highFlowCheckbox.checked;
        el.querySelector('[data-machine-high-flow-value]').value = attributes[ATTRIBUTE_NAMES.high_flow];
        el.dataset.savedHighFlow = attributes[ATTRIBUTE_NAMES.high_flow];
        el.dataset.noteOutOfDate = 'false';
      });
      this.dataset.noteOutOfDate = 'false';

      if (window.CartMachineNote) {
        window.CartMachineNote.save({ attributes });
        return;
      }

      fetch(theme.routes.cartUpdate, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes })
      });
    }
  }

  customElements.define('cart-machine', CartMachine);
}
